import { LocaleEnum } from "@momo/i18n";
import { z } from "zod";
import { Id } from "./workspace.entity.ts";

// The server chooses the verified recipient from the authenticated account.
export const RequestRevolutSandboxConfirmationInput = z
	.object({
		orgId: Id,
		locale: LocaleEnum.optional(),
	})
	.strict();
export type RequestRevolutSandboxConfirmationInput = z.infer<
	typeof RequestRevolutSandboxConfirmationInput
>;

export const RequestRevolutSandboxConfirmationOutput = z
	.object({
		email: z.string().email(),
		expiresAt: z.number().int().positive(),
		resendAt: z.number().int().positive(),
	})
	.strict();
export type RequestRevolutSandboxConfirmationOutput = z.infer<
	typeof RequestRevolutSandboxConfirmationOutput
>;
